import React from 'react';
import _ from 'lodash';
import {connectWithCore} from 'framework/hocs';
import {checkIfValuesAre, evaluateOperator} from 'common/utils';
import {ContentDispatch} from 'framework';
import {ShowHide as _ShowHide} from 'app-ui-componentlibrary/dist/componentLibrary/layout/ShowHide';

export const shouldDisplay = (data, toMatch, shouldDisplayRules, props) => {
  let shouldDisplay = false;
  let shouldDisplayIfAnyRules = props.shouldDisplayIfAnyRules;

  if (data !== undefined && toMatch !== undefined) {
    shouldDisplay = checkIfValuesAre(toMatch, data);
  } else if (data !== undefined) {
    shouldDisplay = true;
  } else if (shouldDisplayRules) {
    // AND
    // [a,b,c,d] => (A&&B&&C&&D)
    shouldDisplay = true;
    _.forEach(shouldDisplayRules, (rule) => {
      // All rules should pass, show component
      shouldDisplay &= evaluateOperator(
        rule.operator,
        _.get(props, rule.propsPath),
        rule.valuePath ? props[rule.valuePath] : rule.value,
        rule.checkType,
        props
      );
    });
  } else if (shouldDisplayIfAnyRules) {
    // OR
    // [ [a, b], [c,d,e] ] => (A&&B) || (C&&D&&E)
    shouldDisplay = false;
    _.forEach(shouldDisplayIfAnyRules, (rules) => {
      let shouldDisplayRuleSet = true;
      _.forEach(rules, (rule) => {
        // All rules should pass, show component
        shouldDisplayRuleSet &= evaluateOperator(
          rule.operator,
          _.get(props, rule.propsPath),
          rule.valuePath ? props[rule.valuePath] : rule.value,
          rule.checkType,
          props
        );
      });
      if (shouldDisplayRuleSet) {
        shouldDisplay = true;
        return false;
      }
    });
  }

  return shouldDisplay;
};

export const ShowHide = (props) => <_ShowHide {...props} {...{shouldDisplay}} />;
export default connectWithCore(ShowHide);
